<template>
  <canvas
    :id="chartData.id"
  />
</template>
<script>

import Chart from 'chart.js/auto'

export default {
  name: 'BasePieChart',
  props: {
    chartData: {
      type: Object,
      default: () => { }
    }
  },  
  data () {
    return {
      chart: null
    }
  },
  computed: {
    options () {
        return {
        hover: { mode: null },
        maintainAspectRatio: true,
        responsive: false,
        plugins: {
          legend: {
          display: false          
        },
        datalabels: {
          display: false
        },
        tooltip: {
          callbacks: {
            title: (context) => {
              return context[0].label
            },
            label: (context) => {
              return context.dataset.legendTooltip.title + ' : ' + context.dataset.legendTooltip.value[context.dataIndex] + ' ' + context.dataset.legendTooltip.unit 
            }
          },
            backgroundColor: 'rgba(0, 0, 0, 0.87)',
            titleFontSize: 14,
            titleFontColor: 'white',
            bodyFontColor: 'white',
            bodyFontSize: 13
          },
        }        
      }
    }
  },  
  watch: {
    chartData: {
      handler () {
        this.chart.data = this.chartData
        this.chart.update()
      }
    },
    options: {
      handler () {
        this.chart.options = this.options
        this.chart.update()
      }
    }
  },
  mounted () {
    const pieChartHtmlElement = document.getElementById(this.chartData.id)
    const config = {
      type: 'pie',
      data: this.chartData,
      options: this.options
    }
    this.chart = new Chart(pieChartHtmlElement, config)
  }
}
</script>
<style lang="scss" scoped>
canvas {
  height: 150px !important;
  width: 150px !important;
}
</style>
